import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from 'routes/MainRoutes';
import AuthenticationRoutes from 'routes/AuthenticationRoutes';
import AdminRoutes from 'routes/AdminRoutes';
import OwnerRoutes from 'routes/OwnerRoutes';
import IngredientsRoutes from 'routes/IngredientsRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function AppRoutes() {
    return useRoutes([AuthenticationRoutes, MainRoutes, AdminRoutes, OwnerRoutes, IngredientsRoutes]);
}
